<div id="mail-confirm" fxLayout="column">

    <div id="mail-confirm-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="mail-confirm-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div *ngIf="!loading" class="logo">
                <mat-icon class="mat-accent s-96">email</mat-icon>
            </div>

            <div *ngIf="!loading && tipoAccion=='envioEmail'" class="title">{{ 'MAIL_CONFIRM.TITLE' | translate}}</div>

            <div *ngIf="!loading && tipoAccion=='envioEmail'" class="subtitle">
                <p>
                    {{ 'MAIL_CONFIRM.TEXT_1' | translate}} <strong>{{email ? email : 'email'}}</strong>.
                </p>
                <p>
                    {{ 'MAIL_CONFIRM.TEXT_2' | translate}}
                </p>
            </div>

            <div *ngIf="!loading && tipoAccion=='validacion'" class="title">{{ 'MAIL_CONFIRM.VALIDATION.TITLE' | translate}}</div>

            <div *ngIf="!loading && tipoAccion=='validacion'" class="subtitle">
                <p>
                    {{ 'MAIL_CONFIRM.VALIDATION.TEXT_1' | translate}}
                </p>
                <p>
                    {{ 'MAIL_CONFIRM.VALIDATION.TEXT_2' | translate}}
                </p>
            </div>

            <div *ngIf="!loading && tipoAccion=='muestraError'" class="title">{{ 'MAIL_CONFIRM.ERROR.TITLE' | translate}}</div>

            <div *ngIf="!loading && tipoAccion=='muestraError'" class="subtitle">
                <p *ngIf="mensaje1">
                    {{ mensaje1 }}
                </p>
                <p *ngIf="mensaje2">
                    {{ mensaje2 }}
                </p>
            </div>

            <div *ngIf="!loading" class="message">
                <a class="link" [routerLink]="'/pages/auth/login'">{{ 'MAIL_CONFIRM.BACK' | translate}}</a>
            </div>
        </div>
    </div>
    <div *ngIf="loading">
        <app-loading class="loader"></app-loading>
    </div>

</div>
